import { AlertCircle, X } from "lucide-react"

interface ErrorDisplayProps {
  error: string | null
  onDismiss: () => void
}

export default function ErrorDisplay({ error, onDismiss }: ErrorDisplayProps) {
  if (!error) return null

  return (
    <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 flex items-center gap-3">
      <AlertCircle className="w-5 h-5 text-red-600" />
      <p className="text-red-800">{error}</p>
      <button
        onClick={onDismiss}
        className="ml-auto text-red-600 hover:text-red-800"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  )
}
